export var AttachmentType;
(function (AttachmentType) {
    // Service should never return this value.
    AttachmentType[AttachmentType["None"] = 0] = "None";
    // Classic attachment
    AttachmentType[AttachmentType["Classic"] = 1] = "Classic";
    // Modern (i.e. cloud based) attachment
    AttachmentType[AttachmentType["Modern"] = 2] = "Modern";
})(AttachmentType || (AttachmentType = {}));
//# sourceMappingURL=AttachmentType.js.map